export default "__VITE_ASSET__zK6fYwSR__"